import * as React from "react";
function SvgPencil(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M28.8 0L10 37.1l-.1.3L9.3 48l10.5-5.3L38.7 5.3 28.8 0zm1.1 3.6l5.2 2.8-2.7 5.6-5.2-3 2.7-5.4zM17.8 40.7l-5.6 2.8.3-5.5L26 11.4l5.2 2.9-13.4 26.4z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgPencil);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
